import { colors } from "@mui/material";
import { Position, LinkedPosition, GamePositionColor } from "../../types/Game";

const GAME_POSITIONS: Position[] = [
  { x: 352, y: 53},
  { x: 295, y: 53},
  { x: 234, y: 53},
  { x: 168, y: 53},
  { x: 110, y: 57, color: GamePositionColor.Yellow },
  { x: 65, y: 62 },
  { x: 33, y: 101, color: GamePositionColor.Blue },
  { x: 36, y: 153 },
  { x: 78, y: 200 },
  { x: 147, y: 195, color: GamePositionColor.Red },
  { x: 207, y: 195, color: GamePositionColor.Red },
  { x: 270, y: 205 },
  { x: 326, y: 215 },
  { x: 380, y: 228, color: GamePositionColor.Yellow },
  { x: 438, y: 255 },
  { x: 495, y: 267, color: GamePositionColor.Red },
  { x: 560, y: 265, color: GamePositionColor.Blue },
  { x: 613, y: 219, color: GamePositionColor.Blue },
  { x: 651, y: 168 },
  { x: 675, y: 120 },
  { x: 699, y: 69, color: GamePositionColor.Green },
  { x: 748, y: 48 },
  { x: 804, y: 48 },
  { x: 855, y: 53, color: GamePositionColor.Yellow },
  { x: 900, y: 85 },
  { x: 923, y: 137, color: GamePositionColor.Blue },
  { x: 935, y: 200, color: GamePositionColor.Red },
  { x: 930, y: 256, color: GamePositionColor.Red },
  { x: 901, y: 311 },
  { x: 842, y: 350, color: GamePositionColor.Blue },
  { x: 785, y: 357, color: GamePositionColor.Green },
  { x: 725, y: 366 },
  { x: 668, y: 355 },
  { x: 600, y: 360, color: GamePositionColor.Red },
  { x: 556, y: 370 },
  { x: 511, y: 410, color: GamePositionColor.Yellow },
  { x: 480, y: 455, color: GamePositionColor.Yellow },
  { x: 420, y: 478 },
  { x: 374, y: 430, color: GamePositionColor.Blue },
  { x: 333, y: 366, color: GamePositionColor.Blue },
  { x: 277, y: 320 },
  { x: 218, y: 295, color: GamePositionColor.Green },
  { x: 160, y: 300 },
  { x: 97, y: 330, color: GamePositionColor.Green },
  { x: 63, y: 384 },
  { x: 54, y: 445 },
  { x: 65, y: 505, color: GamePositionColor.Yellow },
  { x: 98, y: 560, color: GamePositionColor.Yellow },
  { x: 165, y: 582 },
  { x: 235, y: 580, color: GamePositionColor.Red },
  { x: 297, y: 572 },
  { x: 357, y: 578 },
  { x: 420, y: 595, color: GamePositionColor.Blue },
  { x: 465, y: 630, color: GamePositionColor.Blue },
  { x: 502, y: 664 },
  { x: 580, y: 670 },
  { x: 633, y: 625, color: GamePositionColor.Yellow },
  { x: 660, y: 570 },
  { x: 683, y: 516 },
  { x: 730, y: 482, color: GamePositionColor.Red },
  { x: 780, y: 468, color: GamePositionColor.Red },
  { x: 836, y: 474 },
  { x: 884, y: 500 },
  { x: 915, y: 550, color: GamePositionColor.Blue },
  { x: 921, y: 620 },
  { x: 905, y: 677 },
  { x: 855, y: 726, color: GamePositionColor.Yellow },
  { x: 811, y: 747 },
  { x: 755, y: 757 },
  { x: 700, y: 775, color: GamePositionColor.Green },
  { x: 640, y: 780, color: GamePositionColor.Red },
  { x: 578, y: 778 },
  { x: 520, y: 775, color: GamePositionColor.Green },
  { x: 455, y: 769 },
  { x: 374, y: 752 },
  { x: 327, y: 730 },
  { x: 264, y: 706, color: GamePositionColor.Green },
  { x: 206, y: 690, color: GamePositionColor.Yellow },
  { x: 150, y: 697, color: GamePositionColor.Blue },
  { x: 98, y: 725 },
  { x: 60, y: 766 },
  { x: 45, y: 820, color: GamePositionColor.Green },
  { x: 70, y: 870, color: GamePositionColor.Green },
  { x: 112, y: 904 },
  { x: 175, y: 925 },
  { x: 237, y: 925, color: GamePositionColor.Yellow },
  { x: 302, y: 925, color: GamePositionColor.Green },
  { x: 366, y: 925 },
  { x: 430, y: 925, color: GamePositionColor.Red },
  { x: 492, y: 925, color: GamePositionColor.Green },
  { x: 548, y: 925 },
  { x: 608, y: 924, color: GamePositionColor.Blue },
  { x: 670, y: 923 },
  { x: 724, y: 922 },
  { x: 787, y: 921, color: GamePositionColor.Green },
  { x: 845, y: 920 },
  { x: 900, y: 913 },
];

const START_POSITIONS = [
  { x: 440, y: 53 },
  { x: 480, y: 53 },
  { x: 520, y: 53 },
  { x: 560, y: 53 },
  { x: 600, y: 53 },
];

const LINKED_POSITIONS = [
  { from: 2, to: 10, type: "slide" },
  { from: 31, to: 60, type: "slide" },
  { from: 32, to: 17, type: "ladder" },
  { from: 42, to: 9, type: "slide" },
  { from: 73, to: 89, type: "slide" },
  { from: 74, to: 53, type: "ladder" },
  { from: 92, to: 70, type: "ladder" },
];

const getStartCoordenates = (): Array<Position> => {
  return START_POSITIONS;
};

const getAllCoordenates = (): Array<Position> => {
  return GAME_POSITIONS;
};
const getLinkedCoordenates = (): Array<LinkedPosition> => LINKED_POSITIONS;

export default {
  getAllCoordenates,
  getLinkedCoordenates,
  getStartCoordenates,
};
